import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ShowPromos from '../views/ShowPromos.vue';
import PromoDetail from '../views/PromoDetail.vue';
import PromoSuccess from '../views/PromoSuccess.vue';
import Explain from '../views/Explain.vue';
import Boo from '../views/Boo.vue';
import Contact from '../views/Contact.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/promos",
    name: "Promos",
    component: ShowPromos
  },
  {
    path: '/promo/:id',
    name: 'PromoDetail',
    component: PromoDetail,
    props: true
  },
  {
    path: '/success-thank-you',
    name: 'PromoSuccess',
    component: PromoSuccess,
  },
  {
    path: '/how-it-works',
    name: 'Explain',
    component: Explain,
  },
  {
    path: '/boo',
    name: 'Boo',
    component: Boo,
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: Contact,
  },

];

const router = new VueRouter({
  routes,
  mode: "history"
});

export default router;
